export default __webpack_public_path__ + "static/media/ideiasXL.1a2975a9.png";